// src/data/audio.js

export const audioItems = [
  {
    id: 1,
    title: "Day 1 — Threshold",
    description: "What is a ritual?",
    file: "/audio/day_1_final.mp3"
  },
  {
    id: 2,
    title: "Day 2 — Devotion",
    description: "What would you make if no one ever witnessed it?",
    file: "/audio/day_2_final.mp3"
  },
   {
    id: 3,
    title: "Day 3 — Desire capacity",
    description: "What did you want when you were a kid?",
    file: "/audio/day_3_final.mp3"
  },
     {
    id: 4,
    title: "Day 4 — Art as necessity",
    description: "What accumulates if you don't create?",
    file: "/audio/day_4_final.mp3"
  },
       {
    id: 5,
    title: "Day 5 — Follow your bliss",
    description: "Describe your bliss",
    file: "/audio/day_5_final.mp3"
  },
         {
    id: 6,
    title: "Day 6 — Hero",
    description: "Slay the dragon",
    file: "/audio/day_6_final.mp3"
  },
          {
    id: 7,
    title: "Day 7 — Discipline as love",
    description: "What is your devotion?",
    file: "/audio/day_7_final.mp3"
  },

           {
    id: 8,
    title: "Day 8 — Entering the unknown",
    description: "What does the unknowable want?",
    file: "/audio/day_8_final.mp3"
  },

           {
    id: 9,
    title: "Day 9 — Negative capability",
    description: "Stay inside a question without answering it.",
    file: "/audio/day_9_final.mp3"
  },

           {
    id: 10,
    title: "Day 10— Trauma as tuning",
    description: "What can you perceive that others cannot?",
    file: "/audio/day_10_final.mp3"
  },

           {
    id: 11,
    title: "Day 11 — Discomfort as signal",
    description: "What discomfort is a compass?",
    file: "/audio/day_11_final.mp3"
  },

           {
    id: 12,
    title: "Day 12 — Doubt as intelligence",
    description: "Doubt your doubt",
    file: "/audio/day_12_final.mp3"
  },

           {
    id: 13,
    title: "Day 13 -Limitation as structure",
    description: "A love letter to limitations",
    file: "/audio/day_13_final.mp3"
  },

           {
    id: 14,
    title: "Day 14 — Identity dissolution",
    description: "If marble can melt..",
    file: "/audio/day_14_final.mp3"
  },

             {
    id: 15,
    title: "Day 15 — Surrender",
    description: "Identify the Grip",
    file: "/audio/day_15_final.mp3"
  },

             {
    id: 16,
    title: "Day 16 — Trust",
    description: "Something is occurring beneath the surface",
    file: "/audio/day_16_final.mp3"
  },

             {
    id: 17,
    title: "Day 17 — Becoming conduit",
    description: "What does an idea look like? feel like?",
    file: "/audio/day_17_final.mp3"
  },
             {
    id: 18,
    title: "Day 18 — Rest as creative act",
    description: "Describe rest as a place",
    file: "/audio/day_18_final.mp3"
  },

               {
    id: 19,
    title: "Day 19 — Faith without evidence",
    description: "Make your own proof",
    file: "/audio/day_19_final.mp3"
  },

               {
    id: 20,
    title: "Day 20 — Integration",
    description: "What has shifted?",
    file: "/audio/day_20_final.mp3"
  },

               {
    id: 21,
    title: "Day 21 — The Signal Continues",
    description: "Living as a receiver",
    file: "/audio/day_21_final.mp3"
  },


]